import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  ITag,
} from '@kinet-open-network/shared/data-access/model';
import { ColorCode } from '@kinet-open-network/shared/util';

export class Tag extends BaseModel<Tag, 'Tag'> implements ITag {
  static override readonly modelName: AbilitySubjectType = 'Tag';

  label!: string;
  code!: string;
  color!: ColorCode;
}
